import jwtAuthAxios from "../auth/jwtAuth";
import { setAuthBackendDomain } from "./management";

export const getTemplates = async () => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get("/presentation/templates");
  return data.data;
};

export const createPresentationFromTemplate = async (
  templateUrl,
  customerId
) => {
  const bodyFormData = new FormData();
  bodyFormData.append("url", templateUrl);
  bodyFormData.append("customerId", customerId);
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post(
    "/presentation/create-from-template",
    bodyFormData
  );
  return data.url;
};
